import { ApolloProvider } from '@apollo/client';
import { theme, EnvironmentRibbon, getFrontendConfigValue, ToastProvider } from '@arnold/common';
import { ThemeProvider } from '@emotion/react/macro';
import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import { ScrollToTop } from './components';
import Modal from './components/Modals/ModalController';
import CookieConsent from './components/CookieConsent';
import apolloClient from './createApollo';
import ErrorBoundary from './ErrorBoundary';
import { allowedLanguages } from './lib/common';
import i18n from './translations/i18n';
import { Routes } from './Routes';
import cookies from 'js-cookie';
import storage from './lib/storage';

const App = () => {
  useEffect(() => {
    const savedLang = cookies.get('i18next') || storage.getDetectedLanguage()?.substring(0, 2);
    const languages = i18n.languages;
    const browserLang = languages[0];
    const lang = savedLang ?? (allowedLanguages.find((al) => al === browserLang.substring(0, 2)) || languages[1]);
    i18n.changeLanguage(lang);
  }, []);

  return (
    <BrowserRouter>
      <EnvironmentRibbon env={getFrontendConfigValue('ENVIRONMENT')} />
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={theme}>
          <ToastProvider>
            <ErrorBoundary>
              <Modal>
                <>
                  <CookieConsent />
                  <ScrollToTop />
                  <Routes />
                </>
              </Modal>
            </ErrorBoundary>
          </ToastProvider>
        </ThemeProvider>
      </ApolloProvider>
    </BrowserRouter>
  );
};

export default App;
